import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import formatNumberByLocale from '@utils/format-number-by-locale'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@components/UI-Components/HierarchyWiseItems/constants'

const EnhancedHierarchyKPIDetails: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const { uiStore } = useViewContext()
    const {
      getOrderHierarchyKPIs,
      dataStore: { heirarchy }
    } = uiStore as EnhancedListUIStore<any>
    const hierarchy = getOrderHierarchyKPIs(rowData?.name, heirarchy)
    const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)
    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    return (
      <HierarchyCell>
        <Typography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
          {formatNumberByLocale(hierarchy?.[column.field] || 0, 0, 2)}
        </Typography>
      </HierarchyCell>
    )
  })

export default EnhancedHierarchyKPIDetails
